import { Toast } from '../../../../shared/Toast';
import { useCallback } from 'react';

export default function useToast() {
  return useCallback((type, message) => {
    Toast(type, message);
  }, []);
} 